import { useState } from 'react';
import { Markup } from 'interweave';
import { Box, Button, Flex, Image, Text } from '@enaep-ng/benchmark';
import * as styleSheet from '../styles';
import React from 'react';
import { ActionComponent } from '../types';



const Icon = (props: { src: string }) => {
  return <Image src={props.src} style={styleSheet.actionIconStyle} />;
};

const Icon2 = (props: { src: string }) => {
  return <Image src={props.src} style={styleSheet.actionIconStyle2} />;
};

const ActionButton: React.FC<ActionComponent> = (props) => {
  const {label, iconSrc, content, actionDescription, action, iconSrc2} = props;
  const [hovering, setHovering] = useState(false);
  const aniStep1 = 0.18;

  return (
    <>
    {props.iconSrc2 && <Icon2 src={props.iconSrc2} />}
      <Box
        sx={{
          flex: "50%",
          textAlign: "center",
          padding: "0 calc(27px * var(--zoom))",
      }}>
        <Box sx={{
            width: "calc(293px * var(--zoom))",
            textAlign: "center",
            backgroundColor: `${hovering ? "#0d69be" : "#0a1971"}`,
            transition: `background-color ${aniStep1}s`,
            cursor: "pointer",
            color: "#FFF",
            borderRadius: "calc(10px * var(--zoom))",
            padding: "calc(20px * var(--zoom))",
            display: "block",
            margin: "0 auto"
          }}
          onMouseEnter={()=>setHovering(true)}
          onMouseLeave={()=>setHovering(false)}
          onClick={action}
        >
          <Box sx={{
            width: "calc(50px * var(--zoom))",
            height: "calc(50px * var(--zoom))",
            display: "block",
            margin: "calc(4px * var(--zoom)) auto calc(10px * var(--zoom))",
          }}>
            <Icon src={iconSrc} />
          </Box>
          <Flex sx= {{justifyContent: "center"}}>
            <Text fontSize={1} 
              sx={{
                pt: "calc(6px * var(--zoom))",
                margin: 0,
                fontWeight: "bold",
                fontSize: "calc(18px * var(--zoom))"
              }}
            ><Markup content={label}/></Text>
          </Flex>
          <Flex sx= {{justifyContent: "center"}}>
            <Text fontSize={1} 
              sx={{
                paddingTop: "calc(2px * var(--zoom))",
                margin: 0,
              }}
            ><Markup content={content}/></Text>
          </Flex>
        </Box>
        <Text fontSize={1}
          sx={{
            color: "#000",
            maxWidth: "calc(250px * var(--zoom))",
            display: "block",
            margin: "calc(16px * var(--zoom)) auto 0",
            lineHeight: "calc(22px * var(--zoom))"
          }}
        ><Markup content={actionDescription}/></Text>
      </Box>
    </>
  );
};

export default ActionButton;
